export default __webpack_public_path__ + "08348de8f94dd3cb24c039b417942929.png";